import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

/**
 * A wrapper that prevent the wrapped route from being accessed by the normal user. Only an agent or an unauthenticated user can access it.
 *
 * @returns {JSX.Element}
 */

const PreventNormalUserRoute = () => {
  const { user } = useSelector((state) => state.authData);
  return !user || user.agent ? <Outlet /> : <Navigate to="/" />;
};

export default PreventNormalUserRoute;
